import { api } from '@/api/main.api'

export async function apiGetProjects (state, sort, cursor) {
  return api('get', `/v3/project/list?projectState=${state}&sort=${sort}&limit=20&cursor=${cursor}`)
}

export async function apiGetProjectsAll (state, sort) {
  return api('get', `/v3/project/list?projectState=${state}&sort=${sort}`)
}

export async function apiUpdateProjectData (param) {
  return api('post', '/v3/project/updateData', param)
}

export async function apiProjectRemove (projectId) {
  return api('delete', `/v3/project/${projectId}`)
}

export async function apiProjectUpdateStatus (id, state) {
  return api('post', '/v3/project/changeState', {id, state})
}

export async function apiGetDribbbleShots (token) {
  return api('get', `https://api.dribbble.com/v2/user/shots?access_token=${token}`)
}



// WEBPACK FOOTER //
// ./src/api/projects.api.js